function YellowWarnIcon(props: {}) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.5 12.25C21.5 7.14123 17.3588 3 12.25 3C7.14123 3 3 7.14123 3 12.25C3 17.3588 7.14123 21.5 12.25 21.5C17.3588 21.5 21.5 17.3588 21.5 12.25ZM12.25 7.625C12.4953 7.625 12.7306 7.72246 12.9041 7.89593C13.0775 8.0694 13.175 8.30467 13.175 8.55V13.175C13.175 13.4203 13.0775 13.6556 12.9041 13.8291C12.7306 14.0025 12.4953 14.1 12.25 14.1C12.0047 14.1 11.7694 14.0025 11.5959 13.8291C11.4225 13.6556 11.325 13.4203 11.325 13.175V8.55C11.325 8.30467 11.4225 8.0694 11.5959 7.89593C11.7694 7.72246 12.0047 7.625 12.25 7.625ZM11.325 15.95C11.325 15.7047 11.4225 15.4694 11.5959 15.2959C11.7694 15.1225 12.0047 15.025 12.25 15.025H12.2574C12.5027 15.025 12.738 15.1225 12.9115 15.2959C13.0849 15.4694 13.1824 15.7047 13.1824 15.95C13.1824 16.1953 13.0849 16.4306 12.9115 16.6041C12.738 16.7775 12.5027 16.875 12.2574 16.875H12.25C12.0047 16.875 11.7694 16.7775 11.5959 16.6041C11.4225 16.4306 11.325 16.1953 11.325 15.95Z"
				fill="#7E5202"
			/>
		</svg>
	);
}

function YellowCrossIcon(props: {}) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.5 12.25C21.5 17.3586 17.3586 21.5 12.25 21.5C7.14137 21.5 3 17.3586 3 12.25C3 7.14137 7.14137 3 12.25 3C17.3586 3 21.5 7.14137 21.5 12.25Z"
				fill="#7E5202"
			/>
			<path
				d="M8.78125 15.7188L15.7188 8.78125"
				stroke="#FEE4B4"
				strokeWidth="1.3"
				strokeLinecap="round"
			/>
			<path
				d="M15.7188 15.7188L8.78125 8.78125"
				stroke="#FEE4B4"
				strokeWidth="1.3"
				strokeLinecap="round"
			/>
		</svg>
	);
}

export { YellowWarnIcon, YellowCrossIcon };
